import React, { Fragment, useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'

import LoadCollections from './LoadCollections/LoadCollections'

const Layout = ({ account, audience, campaign, template }) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname.split('/').length <= 2) {
      navigate('/organizations')
    }
  }, [pathname, navigate])

  return (
    <Fragment>
      {account.init && audience.init && campaign.init && template.init && (
        <Outlet />
      )}
      <LoadCollections />
    </Fragment>
  )
}

export default connect((state) => {
  return state
})(Layout)
